import React, { forwardRef, useImperativeHandle } from 'react';
import Chip from '@mui/material/Chip';
import LinearProgress from '@mui/material/LinearProgress';
import Button from '@mui/material/Button';
import { Modal, Box, Typography } from '@mui/material';

const Step2 = forwardRef((props, ref) => {
  const [accesoMicrofonoVerificado, setAccesoMicrofonoVerificado] = React.useState(null);
  const [funcionamientoMicrofono, setFuncionamientoMicrofono] = React.useState(null);
  const [porcentajeVerificacionesFuncionamiento, setPorcentajeVerificacionesFuncionamiento] = React.useState(0);
  const [mostrarMensajeModal, setMostrarMensajeModal] = React.useState(false);
  const [contenidoMensajeModal, setContenidoMensajeModal] = React.useState("");
  const [pasoExitoso, setPasoExitoso] = React.useState(null);

  const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 200,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };

  useImperativeHandle(ref, () => ({
    getPasoExitoso() {
      return pasoExitoso
    },
    getAccesoMicrofonoVerificado() {
      return accesoMicrofonoVerificado
    },
    getFuncionamientoMicrofono() {
      return funcionamientoMicrofono
    },
  }));

  const verificarAccesoMicrofono = (callback) => {
    navigator.mediaDevices.getUserMedia({ audio: true })
    .then(function(stream) {
      setAccesoMicrofonoVerificado(true);
      stream.getTracks().forEach(track => track.stop());
      callback(true);
    })
    .catch(function(error) {
      setAccesoMicrofonoVerificado(false);
      console.log("Nombre de error original: " + error.name);
      console.log("Mensaje de error original: " + error.message);
      if (error.name === 'NotAllowedError') {
        console.error('El usuario denegó el acceso a los dispositivos de medios.');
      } else if (error.name === 'NotFoundError' || error.name === 'DevicesNotFoundError') {
        console.error('No se encontraron dispositivos de medios compatibles.');
      } else if (error.name === 'NotReadableError' || error.name === 'TrackStartError') {
        console.error('No se puede acceder a los dispositivos de medios o el flujo de medios se ha detenido.');
      } else if (error.name === 'OverconstrainedError' || error.name === 'ConstraintNotSatisfiedError') {
        console.error('Las restricciones especificadas no pudieron ser satisfechas.');
      } else if (error.name === 'AbortError') {
        console.error('La operación fue abortada, posiblemente debido a una llamada a mediaDevices.getUserMedia() mientras otra llamada está en curso.');
      } else {
        console.error('Se produjo un error al obtener acceso a los dispositivos de medios:', error.name, error.message);
      }
      callback(false);
    });
  }

  const verificarFuncionamientoMicrofono = (callback) => {
    navigator.mediaDevices.getUserMedia({ audio: true })
    .then(function(stream) {
      setTimeout(function() {
        setMostrarMensajeModal(true);
        setContenidoMensajeModal('Dí en voz alta: "Voy a tener una videoconsulta"');
        let audioContext = new (window.AudioContext || window.webkitAudioContext)();
        let microphone = audioContext.createMediaStreamSource(stream);
        let analyser = audioContext.createAnalyser();
        microphone.connect(analyser);
        let totalVerificaciones = 300;
        let contadorVerificaciones = 0;
        let seEncontroRuido = false;

        function verificarEntradaMicrofonoSignals() {
          // Obtener datos de amplitud del espectro de frecuencias
          var bufferLength = analyser.frequencyBinCount;
          var dataArray = new Uint8Array(bufferLength);
          analyser.getByteFrequencyData(dataArray);

          // Calcular la amplitud promedio del espectro de frecuencias
          var average = 0;
          for (var i = 0; i < bufferLength; i++) {
              average += dataArray[i];
          }
          average /= bufferLength;

          // Determinar si el micrófono está recibiendo señales
          if (average > 0) {
              seEncontroRuido = true;
          }

          contadorVerificaciones++;
          setPorcentajeVerificacionesFuncionamiento(contadorVerificaciones * 100 / totalVerificaciones);
          if (contadorVerificaciones <= totalVerificaciones) {
            // Llamar a esta función nuevamente después de un corto intervalo
            requestAnimationFrame(verificarEntradaMicrofonoSignals);
          } else {
            if (seEncontroRuido) {
              console.log('El micrófono está recibiendo señales.');
              setFuncionamientoMicrofono(true);
              audioContext.close();
              stream.getTracks().forEach(track => track.stop());
              callback(true);
            } else {
              setFuncionamientoMicrofono(false);
              audioContext.close();
              stream.getTracks().forEach(track => track.stop());
              callback(false);
            }
          }
        }
        verificarEntradaMicrofonoSignals();
      }, 2000);
    })
    .catch(function(error) {
      setFuncionamientoMicrofono(false);
      callback(false);
    });
  }

  const init = async () => {
    setAccesoMicrofonoVerificado(null);
    setFuncionamientoMicrofono(null);
    setPasoExitoso(null);
    verificarAccesoMicrofono(function(resultadoAccesoMicrofono) {
      if (resultadoAccesoMicrofono) {
        verificarFuncionamientoMicrofono(function(resultadoFuncionamiento) {
          setMostrarMensajeModal(false);
          if (resultadoFuncionamiento) {
            setPasoExitoso(true);
          } else {
            setPasoExitoso(false);
          }
        });
      } else {
        setFuncionamientoMicrofono(false);
        setPasoExitoso(false);
      }
    });
  }

  const reintentar = () => {
    init();
  }

  React.useEffect(() => {
    init();
  }, []);

  return (
    <div style={{ minHeight: "70vh" }}>
      <h2>Verificación de micrófono</h2>
      <div style={{ marginBottom: "20px", padding: "10px", borderTop: "1px solid lightGray", borderBottom: "1px solid lightGray" }}>
        <div style={{ textAlign: "left", fontSize: "18px", marginBottom: "5px" }}>Acceso:</div>
        {accesoMicrofonoVerificado != null ? accesoMicrofonoVerificado ? <Chip label="Ok, perfecto." color="success" />: <Chip label="No se pudo acceder" color="error" /> : <Chip label="?" color="warning" />}
      </div>
      <div style={{ marginBottom: "20px", padding: "10px", borderTop: "1px solid lightGray", borderBottom: "1px solid lightGray" }}>
        <div style={{ textAlign: "left", fontSize: "18px", marginBottom: "5px" }}>Funcionamiento:</div>
        {funcionamientoMicrofono != null ? funcionamientoMicrofono ? <Chip label="Ok, perfecto." color="success" />: <Chip label="No se detectan señales de audio" color="error" /> : <Chip label="?" color="warning" />}
      </div>

      <Modal
        open={mostrarMensajeModal}
      >
        <Box sx={modalStyle}>
          <Typography sx={{ fontSize: "16px" }}>
            { contenidoMensajeModal }
          </Typography>
          <div style={{ marginTop: "10px" }}>
            <LinearProgress color="success" variant="determinate" value={porcentajeVerificacionesFuncionamiento} />
          </div>
        </Box>
      </Modal>
      {pasoExitoso != null ? pasoExitoso ? <div><h3>¡Estupendo!</h3><p>Tu micrófono está bien configurado.</p><p>Presioná en siguiente para continuar.</p></div> :
      <div><h3>Ups!...</h3><p>No podemos verificar que tu micrófono funcione correctamente.</p><p>Podés reintentar ahora o continuar con la siguiente prueba desde el botón "Siguiente".</p><Button variant="contained" color="primary" onClick={reintentar}>Reintentar</Button></div> :
      <span></span>}
    </div>
  );
});

export default Step2;